import { render, staticRenderFns } from "./areaCodeSelect.vue?vue&type=template&id=6a84b314&scoped=true"
import script from "./areaCodeSelect.vue?vue&type=script&lang=js"
export * from "./areaCodeSelect.vue?vue&type=script&lang=js"
import style0 from "./areaCodeSelect.less?vue&type=style&index=0&id=6a84b314&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a84b314",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/b08365e4-b55a-4269-82b4-b5e5a1490008/workspace/hsylc_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a84b314')) {
      api.createRecord('6a84b314', component.options)
    } else {
      api.reload('6a84b314', component.options)
    }
    module.hot.accept("./areaCodeSelect.vue?vue&type=template&id=6a84b314&scoped=true", function () {
      api.rerender('6a84b314', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form/AreaCodeSelect/areaCodeSelect.vue"
export default component.exports